import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

const ErrorMessage = ({
    message = 'Something went wrong',
    onRetry,
    className = ''
}) => {
    return (
        <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                <ExclamationTriangleIcon className="w-8 h-8 text-red-600" />
            </div>

            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Oops! Something went wrong
            </h3>

            <p className="text-gray-600 text-center mb-6 max-w-md">
                {message}
            </p>

            {onRetry && (
                <button
                    onClick={onRetry}
                    className="btn-primary"
                >
                    Try Again
                </button>
            )}
        </div>
    )
}

export default ErrorMessage
